import { createSlice } from "@reduxjs/toolkit";
import { ThunkHttpClient } from "../../utils/httpThunkClient";

export const saveOrUpdateBusinessProvider = ThunkHttpClient.post('master/saveOrUpdateBusinessProvider', (body) => ({url:'master/saveOrUpdateBusinessProvider', body}));
export const fetchAllBusinessFrom = ThunkHttpClient.get('master/fetchAllBusinessFrom', (status) => `master/fetchAllBusinessFrom?status=${status}`);
export const fetchAllBusinessProviders = ThunkHttpClient.get('master/fetchAllBusinessProviders', (status) => `master/fetchAllActiveBusinessProvider?status=${status}`);
export const fetchProfitCenterByBusinessFromId = ThunkHttpClient.get('master/fetchProfitCenterByBusinessFromId', (businessFromId) => `master/fetchProfitCenterByBusinessFromId?businessFromId=${businessFromId}`);
export const updateBusinessProviderStatus = ThunkHttpClient.put('master/updateBusinessProviderStatus', (data) => ({url: `master/updateBusinessProviderStatus?id=${data.id}&active=${data.active}`, body: data}));

const initialState = {      
    loading: false,
    businessFromData: [],
    profitCenterData: [],
    businessProviderData: []
}

export const businessProviderSlice = createSlice({
    name: 'businessProvider',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        // Save or Update Customer Data
        builder.addCase(saveOrUpdateBusinessProvider.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(saveOrUpdateBusinessProvider.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(saveOrUpdateBusinessProvider.rejected, (state, action) => {
            state.loading = false;
        });

        // Fetch All Business From
        builder.addCase(fetchAllBusinessFrom.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAllBusinessFrom.fulfilled, (state, action) => {
            state.loading = false;
            state.businessFromData = action.payload.data;
        });
        builder.addCase(fetchAllBusinessFrom.rejected, (state, action) => {
            state.loading = false;
        });

        // Fetch All Business Providers
        builder.addCase(fetchAllBusinessProviders.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAllBusinessProviders.fulfilled, (state, action) => {
            state.loading = false;
            state.businessProviderData = action.payload.data;
        });
        builder.addCase(fetchAllBusinessProviders.rejected, (state, action) => {
            state.loading = false;
        });

        // Fetch Profit Center By Business From Id
        builder.addCase(fetchProfitCenterByBusinessFromId.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchProfitCenterByBusinessFromId.fulfilled, (state, action) => {
            state.loading = false;
            state.profitCenterData = action.payload.data;
        });
        builder.addCase(fetchProfitCenterByBusinessFromId.rejected, (state, action) => {
            state.loading = false;
        });

        // Update Business Provider Status
        builder.addCase(updateBusinessProviderStatus.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateBusinessProviderStatus.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(updateBusinessProviderStatus.rejected, (state, action) => {
            state.loading = false;
        });
    },
});

export default businessProviderSlice.reducer;
